import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Button, Tooltip, Badge, Input, Table, Card, CardHeader, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Spinner, Alert, Progress } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/kenaikanpangkatService";

import DataTableBloc from "../Blocs/DataTableBloc";
import IndexBloc from "../Blocs/IndexBloc";
import apiResponse from "../../../../../services/apiResponse";
import moment from "moment";
import { Link } from 'react-router-dom'
import SKModal from "./SKModal";
import SKCollectiveModal from "./SKCollectiveModal"
import { AvField, AvForm } from "availity-reactstrap-validation";
import * as XLSX from 'xlsx'; 

class TableSecondComponent extends Component {
	dataTableBloc = new DataTableBloc();
	indexBloc = new IndexBloc();

	historyTable = "PegawaiPromotionsTableSecond";
	defaultOrder = "promotion_employee_name";
	defaultSize = 10;
	defaultSort = "asc";
	configDatatable = {
		...config("datatable"),
		sort: {
			column: this.defaultOrder,
			order: this.defaultSort,
		},
	};
	modal_confirm_status = 0
	modal_confirm_message = ""
	modal_confirm_sucess_message = "data berhasil diproses"
	modal_confirm_error_message = "data gagal diproses"

	// Mapping Jenis Kenaikan Pangkat
	jenisKenaikanPangkatMap = {
		'Reguler': '12112af3-6747-49a5-8f9b-9b119011a6f1',
		'Struktural': 'e10f46fd-31e9-459d-b713-246629c19c26',
		'Fungsional': 'b86966d5-5932-461b-8ea9-7f427e36df4c',
		'Anumerta': 'a15084b8-a27b-44ce-b466-8c78ef250f79',
		'Pengabdian': '6d6e4634-d333-47ea-8af6-b58312e5ac54',
		'Penyesuaian Ijazah': '95fda552-af80-46b3-998e-e570e6c5a7ce',
		'TNI': '15625ddc-e1e0-4add-ba79-f1b22501e4e3',
	};

	constructor(props) {
		super(props);
		this.state = {
			tooltip: false,
			berkasUuid: null,
			detailUuid: null,
			inputSKUuid: null,
			updateUuid: null,
			inactiveUuid: null,
			inactiveSKUuid: null,
			defaultSize: 10,
			rows: [],
			totalRow: 0,
			loadingTable: true,
			filter: sessionStorage.getItem(this.historyTable)
				? JSON.parse(sessionStorage.getItem(this.historyTable))
				: {
					filter_value: "",
					page_number: 1,
					page_size: this.defaultSize,
					sort_order: {
						column: this.defaultOrder,
						order: this.defaultSort,
					},
				},
			dataSelected: [],
			checkAll: false,
			modal: false,
			modalSKC: false,
			showModalImportUsulan: false,
			downloadingFile: false,
			isImport: false,
			// Excel processing states
			excelFile: null,
			excelFileName: '',
			processingExcel: false,
			processedExcelData: null,
			excelProgress: 0,
			excelError: null,
			excelValidationErrors: [],
			excelSummary: {
				total: 0,
				valid: 0,
				invalid: 0
			}
		};
		this.fileInputRef = React.createRef();
	}

	toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

	loadData = async () => {
		/* history Datatable */
		sessionStorage.setItem(
			this.historyTable,
			JSON.stringify(this.state.filter)
		);

		/* kirim ke server */
		let offset =
			(this.state.filter.page_number - 1) * this.state.filter.page_size;
		if (this.state.defaultSize !== this.state.filter.page_size) {
			this.setState({
				defaultSize: this.state.filter.page_size,
			});
			offset = 0;
			this.configDatatable.page_number = 1;
		}
		const query = {
			uuid: this.props.uuid,
			search: this.state.filter.filter_value,
			limit: this.state.filter.page_size,
			offset: offset,
			order: this.state.filter.sort_order.column,
			sort: this.state.filter.sort_order.order,
			status: 1,
			is_process: 1
		};
		await this.dataTableBloc.fetchRowTable(query, this.source.token);
	};

	toggle = () => {
		this.setState({ modal: !this.state.modal })
	}

	toggleModalSKC = () => {
		this.setState({ modalSKC: !this.state.modalSKC })
	}

	dateParse = (input) => {
		let res = "-";
		if (input != "" && input != null) {
			res = moment(input).format('DD/MM/YYYY')
		}
		return res;
	}

	handleChecked = (e, uuid) => {
		var checked = e.target.checked;
		if (checked) {
			this.setState({
				dataSelected: [
					...this.state.dataSelected,
					uuid
				]
			})
		} else {
			var filteredAry = this.state.dataSelected.filter(e => e !== uuid)
			this.setState({
				dataSelected: filteredAry
			})
		}
	}

	handleCheckAll = (e) => {
		let checked = e.target.checked;
		let uuidSelected = [];
		let idx = 0;
		for (let i = 0; i < this.state.rows.length; i++) {
			let thisId = this.state.rows[i].promotion_id
			let thisUuid = this.state.rows[i].promotion_uuid

			if (this.state.rows[i].promotion_collective_decree_uuid == null) {
				this.setState({
					[`check${thisId}`]: !this.state.checkAll,
				})
				if (checked == true) {
					uuidSelected[idx] = thisUuid;
				}
				idx++;
			}
		}

		this.setState({
			checkAll: !this.state.checkAll,
			dataSelected: uuidSelected
		})
	}

	handleDownloadDraftSK = (uuid) => {
		this.indexBloc.fetchDownloadDraftSK({
			promotion_uuid: uuid
		});
	}

	handleButtonProcess = () => {
		console.log(this.state.dataSelected)
		this.modal_confirm_message = "Apakah anda yakin akan menambahkan pegawai terpilih?"
		this.modal_confirm_status = 1;
		this.setState({
			confirm: true
		})
	}

	handleButtonExportUsulan = () => {
		this.indexBloc.fetchExportUsulan({
			period_uuid: this.props.uuid,
		});
	}

	handleButtonImportUsulan = () => {
		this.setState({
			showModalImportUsulan: true,
			isImport: true
		})
	}

	handleCloseModalImportUsulan = () => {
		this.setState({
			showModalImportUsulan: false,
			isImport: false,
			excelFile: null,
			excelFileName: '',
			processingExcel: false,
			processedExcelData: null,
			excelProgress: 0,
			excelError: null,
			excelValidationErrors: [],
			excelSummary: {
				total: 0,
				valid: 0,
				invalid: 0
			}
		});

		if (this.fileInputRef.current) {
			this.fileInputRef.current.value = '';
		}
	}

	fetchListSKCollective = () => {
		this.indexBloc.fetchListSKC({ period_uuid: this.props.uuid });
	}

	setTokenAPI = () => {
		if (typeof this.source != typeof undefined) {
			this.source.cancel();
		}
		this.source = cancelToken();
		this.loadData();
	};

	inactiveData = async () => {
		console.log(this.state.inactiveUuid)
		this.setState({
			confirm: true
		})
		await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
	};

	inactiveSKData = async () => {
		this.setState({
			confirm: true
		})
		await this.dataTableBloc.fetchInactiveSK({ uuid: this.state.inactiveSKUuid });
	};

	// Helper function untuk reset semua state import
	resetImportState = () => {
		this.setState({
			isImport: false,
			excelFile: null,
			excelFileName: '',
			processingExcel: false,
			processedExcelData: null,
			excelProgress: 0,
			excelError: null,
			excelValidationErrors: [],
			excelSummary: {
				total: 0,
				valid: 0,
				invalid: 0
			}
		}, () => {
			if (this.fileInputRef.current) {
				this.fileInputRef.current.value = '';
			}
		});
	};

	// Convert Excel date to Y-m-d format
	convertExcelDate = (value) => {
		if (!value) return null;

		try {
			// If it's already a string in date format
			if (typeof value === 'string') {
				value = value.trim();

				// Try various date formats
				const formats = [
					/^(\d{4})-(\d{2})-(\d{2})$/,        // 2026-12-02
					/^(\d{2})\/(\d{2})\/(\d{4})$/,      // 02/12/2026
					/^(\d{2})-(\d{2})-(\d{4})$/,        // 02-12-2026
				];

				for (let format of formats) {
					const match = value.match(format);
					if (match) {
						if (format === formats[0]) {
							// Y-m-d format
							return value;
						} else {
							// d/m/Y or d-m-Y format
							const day = match[1];
							const month = match[2];
							const year = match[3];
							return `${year}-${month}-${day}`;
						}
					}
				}

				// Try Date.parse as fallback
				const timestamp = Date.parse(value);
				if (!isNaN(timestamp)) {
					const date = new Date(timestamp);
					const year = date.getFullYear();
					const month = String(date.getMonth() + 1).padStart(2, '0');
					const day = String(date.getDate()).padStart(2, '0');
					return `${year}-${month}-${day}`;
				}
			}

			// If it's a number (Excel serial date)
			if (typeof value === 'number') {
				// Excel date starts from 1900-01-01
				const excelEpoch = new Date(1899, 11, 30);
				const msPerDay = 24 * 60 * 60 * 1000;
				const date = new Date(excelEpoch.getTime() + value * msPerDay);

				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');

				return `${year}-${month}-${day}`;
			}

			// If it's a Date object
			if (value instanceof Date) {
				const year = value.getFullYear();
				const month = String(value.getMonth() + 1).padStart(2, '0');
				const day = String(value.getDate()).padStart(2, '0');
				return `${year}-${month}-${day}`;
			}

		} catch (error) {
			console.warn('Failed to convert date:', value, error);
		}

		return null;
	};

	// Handle file selection
	handleExcelFileChange = (e) => {
		const file = e.target.files[0];
		if (!file) return;

		// Validasi extension
		const allowedExtensions = ['xlsx', 'xls'];
		const extension = file.name.split('.').pop().toLowerCase();

		if (!allowedExtensions.includes(extension)) {
			this.setState({
				excelError: 'Format file harus Excel (.xlsx atau .xls)',
				excelFile: null,
				excelFileName: ''
			});
			return;
		}

		this.setState({
			excelFile: file,
			excelFileName: file.name,
			excelError: null,
			processedExcelData: null,
			excelValidationErrors: []
		});
	};

	// Process Excel file in browser
	processExcelFile = async () => {
		const { excelFile } = this.state;
		if (!excelFile) {
			this.setState({ excelError: 'Silakan pilih file terlebih dahulu' });
			return;
		}

		this.setState({
			processingExcel: true,
			excelProgress: 0,
			excelError: null,
			excelValidationErrors: []
		});

		try {
			const reader = new FileReader();

			reader.onload = (e) => {
				try {
					this.setState({ excelProgress: 30 });

					const data = new Uint8Array(e.target.result);
					const workbook = XLSX.read(data, { type: 'array' });

					this.setState({ excelProgress: 50 });

					// Ambil sheet pertama (Data Import)
					const firstSheetName = workbook.SheetNames[0];
					const worksheet = workbook.Sheets[firstSheetName];

					// Convert to JSON
					const jsonData = XLSX.utils.sheet_to_json(worksheet, {
						header: 1,
						raw: false,
						defval: ''
					});

					this.setState({ excelProgress: 70 });

					if (jsonData.length <= 1) {
						throw new Error('File kosong atau hanya berisi header');
					}

					// Process data
					const processedRows = [];
					const validationErrors = [];
					let validCount = 0;
					let invalidCount = 0;

					// Skip header (index 0)
					for (let i = 1; i < jsonData.length; i++) {
						const row = jsonData[i];
						const rowNumber = i + 1;

						// Skip empty rows
						if (!row || row.every(cell => !cell || cell.toString().trim() === '')) {
							continue;
						}

						const nip = row[0] ? row[0].toString().trim() : '';
						const jenisKenaikanPangkat = row[1] ? row[1].toString().trim() : '';
						const pangkatBaru = row[2] ? row[2].toString().trim() : '';
						const tmtPangkat = row[3] || '';
						const golRuang = row[4] ? row[4].toString().trim() : '';
						const tahun = row[5] ? row[5].toString().trim() : '';
						const bulan = row[6] ? row[6].toString().trim() : '';
						const jabatan = row[7] ? row[7].toString().trim() : '';

						// Validasi NIP (wajib)
						if (!nip) {
							validationErrors.push(`Baris ${rowNumber}: NIP tidak boleh kosong`);
							invalidCount++;
							continue;
						}

						// Convert TMT Pangkat
						const convertedTmtPangkat = this.convertExcelDate(tmtPangkat);

						// Convert Jenis Kenaikan Pangkat to UUID
						const jenisKenaikanPangkatUuid = this.jenisKenaikanPangkatMap[jenisKenaikanPangkat] || null;

						if (jenisKenaikanPangkat && !jenisKenaikanPangkatUuid) {
							validationErrors.push(`Baris ${rowNumber}: Jenis Kenaikan Pangkat "${jenisKenaikanPangkat}" tidak valid`);
						}

						processedRows.push({
							nip: nip,
							jenis: jenisKenaikanPangkatUuid,
							pangkat_baru: pangkatBaru,
							tmt: convertedTmtPangkat,
							gol_ruang: golRuang,
							tahun: tahun,
							bulan: bulan,
							jabatan: jabatan
						});

						validCount++;
					}

					this.setState({ excelProgress: 100 });

					if (processedRows.length === 0) {
						throw new Error('Tidak ada data valid untuk diimport');
					}

					this.setState({
						processedExcelData: processedRows,
						processingExcel: false,
						excelValidationErrors: validationErrors,
						excelSummary: {
							total: jsonData.length - 1,
							valid: validCount,
							invalid: invalidCount
						}
					});

				} catch (error) {
					this.setState({
						processingExcel: false,
						excelError: error.message,
						excelProgress: 0
					});
				}
			};

			reader.onerror = () => {
				this.setState({
					processingExcel: false,
					excelError: 'Gagal membaca file',
					excelProgress: 0
				});
			};

			reader.readAsArrayBuffer(excelFile);

		} catch (error) {
			this.setState({
				processingExcel: false,
				excelError: error.message,
				excelProgress: 0
			});
		}
	};

	confirmResponse = (response) => {
		console.log(response)

		let forState = {};
		switch (response) {
			case "cancel":
				// Reset state dan panggil helper function
				this.resetImportState();
				forState = {
					confirm: false,
				};
				break;
			case 'confirm':
				forState = {
					loading: true,
					confirm: false
				}
				// Logika kondisi yang lebih jelas
				if (this.state.isImport) {
					// Proses import
					this.submitData()
				} else {
					// Proses delete
					if (this.state.inactiveSKUuid != null) {
						this.inactiveSKData()
					} else if (this.state.inactiveUuid != null) {
						this.inactiveData()
					}
				}

				break;
			case "success":
				forState = {
					success: false,
					redirect: true,
				};
				break;
			case "failed":
				forState = {
					failed: false,
				};
				break;
			default:
		}

		this.setState(forState);
	};

	submitData = async () => {
		const { processedExcelData } = this.state;

		if (!processedExcelData || processedExcelData.length === 0) {
			this.setState({ excelError: 'Silakan proses file Excel terlebih dahulu' });
			return;
		}

		// Kirim data JSON ke backend (bukan FormData)
		const dataToSubmit = {
			periode: this.props.uuid,
			data: processedExcelData
		};

		await this.dataTableBloc.fetchimportDataKenaikanPangkat(dataToSubmit);
	};

	handlerOnSubmit = (e, values) => {
		e.preventDefault();

		const { processedExcelData } = this.state;

		if (!processedExcelData || processedExcelData.length === 0) {
			this.setState({ excelError: 'Silakan proses file Excel terlebih dahulu' });
			return;
		}

		this.modal_confirm_message = `Apakah anda yakin akan mengimport ${processedExcelData.length} data?`;
		this.setState({
			confirm: true,
		});
	};

	handleButtonExportTemplate = () => {
		this.setState({ downloadingFile: true });

		this.dataTableBloc.fetchexportTemplateKenaikanPangkatChannel.subscribe(
			(result) => {
				switch (result.status) {
					case apiResponse.COMPLETED:
						if (result.data.status) {
							let response = result.data.response;
							if (response.file_url) {
								const link = document.createElement("a");
								link.href = response.file_url;
								link.download = response.file_url.split("/").pop();
								document.body.appendChild(link);
								link.click();
								document.body.removeChild(link);
							}
						}
						this.setState({ downloadingFile: false });
						break;
					case apiResponse.ERROR:
						this.setState({ downloadingFile: false });
						break;
					default:
						break;
				}
			}
		);

		this.dataTableBloc.fetchexportTemplateKenaikanPangkat();
	};

	componentDidMount() {
		this.setTokenAPI();

		this.dataTableBloc.rowtableChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.INITIAL:
					this.setState({
						loadingTable: false,
					});
					break;
				case apiResponse.LOADING:
					this.setState({
						loadingTable: true,
					});
					break;
				case apiResponse.COMPLETED:
					const response = result.data.response;

					// set state for every checkbox
					for (let i = 0; i < response.result.length; i++) {
						let thisId = response.result[i].promotion_id
						this.setState({
							[`check${thisId}`]: false
						})
					}
					this.setState({
						totalRow: response.total,
						rows: response.result,
						loadingTable: false,
					});
					break;
				case apiResponse.ERROR:
					break;
				default:
					break;
			}
		});
		this.dataTableBloc.inactiveChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					this.setState({
						loading: false,
						success: true,
						loadingTable: true
					}, function () {
						this.setTokenAPI()
						this.props.handleInactiveSuccess()
						this.fetchListSKCollective()

					});
					break
				case apiResponse.ERROR:
					this.setState({
						loading: false,
						failed: true,
					});
					break
				default:
					break
			}
		})
		this.dataTableBloc.inactiveSKChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					this.setState({
						loading: false,
						success: true,
						loadingTable: true
					}, function () {
						this.setTokenAPI()
						this.fetchListSKCollective()

						//this.props.handleInactiveSuccess()
					});
					break
				case apiResponse.ERROR:
					this.setState({
						loading: false,
						failed: true,
					});
					break
				default:
					break
			}
		})
		this.indexBloc.downloadDraftSKChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.LOADING:
					this.setState({
						loading: true,
					})
					break
				case apiResponse.COMPLETED:
					const link = result.data.response
					window.open(link.file_url, "_blank")
					//window.location.href = link.file_url
					this.setState({
						loading: false,
						success: true
					})
					setTimeout(() => {
						this.setState({
							success: false,
						})
					}, 1000);
					break
				case apiResponse.ERROR:
					this.setState({
						urlFileDetail: link,
						loading: false,
						failed: true
					})
					setTimeout(function () {
						this.setState({
							failed: false,
						})
					}, 1000)
					break
				default:
					break
			}
		})
		this.indexBloc.exportUsulanChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.LOADING:
					this.setState({
						loading: true,
					})
					break
				case apiResponse.COMPLETED:
					const link = result.data.response
					window.open(link.file_url, "_blank")
					//window.location.href = link.file_url
					this.setState({
						loading: false,
						success: true
					})
					setTimeout(() => {
						this.setState({
							success: false,
						})
					}, 1000);
					break
				case apiResponse.ERROR:
					this.setState({
						urlFileDetail: link,
						loading: false,
						failed: true
					})
					setTimeout(function () {
						this.setState({
							failed: false,
						})
					}, 1000)
					break
				default:
					break
			}
		})

		this.indexBloc.listSKCChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					if (result.data.status) {
						let response = result.data.response
						this.setState({
							skc_list: response.result,
						})
					}
					break
				case apiResponse.ERROR:

					break
				default:
					break
			}
		})
		this.fetchListSKCollective()

		this.indexBloc.downloadSKCChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.LOADING:
					this.setState({
						loading: true,
					})
					break
				case apiResponse.COMPLETED:
					const link = result.data.response
					window.open(link.file_url, "_blank")
					//window.location.href = link.file_url
					this.setState({
						loading: false,
						success: true
					})
					setTimeout(() => {
						this.setState({
							success: false,
						})
					}, 1000);
					break
				case apiResponse.ERROR:
					this.setState({
						urlFileDetail: link,
						loading: false,
						failed: true
					})
					setTimeout(function () {
						this.setState({
							failed: false,
						})
					}, 1000)
					break
				default:
					break
			}
		})

		// PERBAIKAN: Reset state import setelah proses selesai
		this.dataTableBloc.fetchimportDataKenaikanPangkatChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					this.setState({
						loading: false,
						success: true,
						loadingTable: true,
						showModalImportUsulan: false,
						processedExcelData : null
					}, function () {
						// Reset semua state import menggunakan helper function
						this.resetImportState();
						this.setTokenAPI()
						this.fetchListSKCollective()
					});
					break
				case apiResponse.ERROR:
					this.setState({
						loading: false,
						failed: true,
						showModalImportUsulan: false,
						processedExcelData : null
					}, function () {
						// Reset semua state import menggunakan helper function
						this.resetImportState();
					});
					break
				default:
					break
			}
		})
	}

	componentWillUnmount() {
		this.dataTableBloc.rowtableChannel.unsubscribe();
	}

	columns = [
		{
			key: "promotion_id",
			text: "Pilih",
			className: "promotion_id",
			sortable: false,
			header: () => {
				return (
					<div className="form-check text-center font-size-16">
						<Input
							className="form-check-input"
							type="checkbox"
							name="checkAll"
							value=""
							checked={this.state.checkAll}
							onChange={(event) => {
								this.handleCheckAll(event)
							}}
						/>
					</div>
				)
			},
			cell: record => {
				const thisId = record.promotion_id
				return (
					<div className="form-check text-center font-size-16">
						<Input
							type="checkbox"
							className="form-check-input"
							id={'checkbox' + thisId}
							onChange={
								(event) => {
									this.handleChecked(event, record.promotion_uuid);
									this.setState({
										[`check${thisId}`]: !this.state[`check${thisId}`]
									})
								}
							}
							checked={this.state[`check${thisId}`]}
						/>
					</div>
				)
			}
		},
		{
			key: "employee_nip",
			text: "Pegawai",
			className: "",
			sortable: true,
			cell: (record) => {
				return (
					<div
						dangerouslySetInnerHTML={{
							__html:
								"<b>" +
								record.employee_nip +
								"</b><br>" +
								record.employee_full_name
						}}
					/>
				);
			},
		},
		{
			key: "promotion_work_unit_name",
			text: "Unit Kerja",
			className: "",
			sortable: true,
			cell: (record) => {
				return (
					<div
						dangerouslySetInnerHTML={{
							__html: ((record.promotion_work_unit_name != null) ? record.promotion_work_unit_name.replace(/»/g, '<br>') : ''),
						}}
					/>
				);
			},
		},
		{
			key: "promotion_rank_name",
			text: "Pangkat",
			className: "",
			sortable: true,
			cell: (record) => {
				return (
					<div
						dangerouslySetInnerHTML={{
							__html: record.promotion_rank_name,
						}}
					/>
				);
			},
		},
		{
			key: "promotion_rank_group_room",
			text: "Golongan",
			className: "",
			sortable: true,
			cell: (record) => {
				return (
					<div
						dangerouslySetInnerHTML={{
							__html: record.promotion_rank_group_room,
						}}
					/>
				);
			},
		},
		{
			key: "rank_group_room",
			text: "Masa Kerja",
			className: "",
			sortable: true,
			cell: record => {
				return (
					<>
						<b>{record.promotion_year_period}</b> Tahun
						<div><b>{record.promotion_month_period}</b> Bulan</div>
					</>
				)
			}
		},


		{
			key: "promotion_tmt_date",
			text: "TMT Pangkat",
			className: "",
			sortable: true,
			cell: (record) => {
				let res = "-";
				if (
					record.promotion_tmt_date != null &&
					record.promotion_tmt_date != ""
				) {
					res = moment(record.promotion_tmt_date).format("DD-MM-YYYY");
				}
				return res;
			},
		},
		{
			key: "rank_type_name",
			text: "Jenis Kenaikan Pangkat",
			className: "",
			sortable: true,
			cell: (record) => {
				return (
					<div dangerouslySetInnerHTML={{ __html: record.rank_type_name }} />
				);
			},
		},
		{
			key: "promotion_status",
			text: "Status",
			sortable: false,
			cell: (record) => {
				let status = parseInt(record.promotion_status);
				if (status == -1) {
					status = (
						<label className="badge rounded-pill bg-soft-info font-size-12">
							Rekomendasi
						</label>
					);
				} else if (status == 0) {
					status = (
						<label className="badge rounded-pill bg-soft-success font-size-12">
							Menunggu Proses
						</label>
					);
				} else if (status == 1) {
					status = (
						<label className="badge rounded-pill bg-soft-success font-size-12">
							Disetujui
						</label>
					);
				} else if (status == 2) {
					status = (
						<label className="badge rounded-pill bg-soft-error font-size-12">
							Ditolak
						</label>
					);
				}
				return <span> {status} </span>;
			},
		},
		{
			key: "action",
			text: "Action",
			className: "action",
			width: 120,
			sortable: false,
			align: "center",
			cell: (record) => {
				const thisId = record.promotion_id;
				return (
					<Fragment>
						{record.promotion_is_rekomendation == 1 &&
							record.promotion_status == -1 &&
							accessRole("update") ? (
							<span>
								<button
									className="btn btn-primary btn-sm"
									id={"update-" + thisId}
									onClick={() => {
										this.setState({
											updateUuid: record.employee_uuid,
										});
									}}
									style={{
										marginRight: "2px",
										padding: "2px 5px",
									}}
								>
									<i className="uil-list-ul"></i>
								</button>
								<Tooltip
									style={{
										marginBottom: 2,
									}}
									placement="top"
									isOpen={this.state["update" + thisId]}
									target={"update-" + thisId}
									toggle={() => {
										this.setState({
											["update" + thisId]: !this.state["update" + thisId],
										});
									}}
								>
									Masukan ke daftar
								</Tooltip>
							</span>
						) : null}

						{record.promotion_status == 0 && accessRole("read") ? (
							<span>
								<button
									className="btn btn-warning btn-sm"
									id={"berkas-" + thisId}
									onClick={() => {
										this.setState({
											berkasUuid: record.employee_uuid,
										});
									}}
									style={{
										marginRight: '2px',
										padding: '2px 5px'
									}}>
									<i className="uil-file-plus-alt"></i>
								</button>
								<Tooltip
									style={{
										marginBottom: 2
									}}
									placement="top" isOpen={this.state["berkas" + thisId]} target={"berkas-" + thisId}
									toggle={() => {
										this.setState({
											["berkas" + thisId]: !this.state["berkas" + thisId]
										})
									}}
								>Berkas</Tooltip>
							</span>
						) : null}

						{record.promotion_status == 0 && record.promotion_decree_number != null && accessRole("read") ? (
							<span>
								<button
									className="btn btn-info btn-sm"
									id={"draftSk-" + thisId}
									onClick={() => {
										this.handleDownloadDraftSK(record.promotion_uuid)
									}}
									style={{
										marginRight: '2px',
										padding: '2px 5px'
									}}>
									<i className="uil-file-download-alt"></i>
								</button>
								<Tooltip
									style={{
										marginBottom: 2
									}}
									placement="top" isOpen={this.state["draftSk" + thisId]} target={"draftSk-" + thisId}
									toggle={() => {
										this.setState({
											["draftSk" + thisId]: !this.state["draftSk" + thisId]
										})
									}}
								>Download Draft SK</Tooltip>
							</span>
						) : null}

						{record.promotion_status == 0 && record.promotion_decree_number != null && accessRole("update") ? (
							<span>
								<Link to={`?verifikasi&uuid=` + this.props.uuid + `&pegawai_uuid=` + record.employee_uuid}>
									<button

										className="btn btn-success btn-sm"
										id={"verifikasi-" + thisId}

										style={{
											marginRight: "2px",
											padding: "2px 5px",
										}}
									>
										<i className="uil-check"></i>
									</button>
									<Tooltip
										style={{
											marginBottom: 2,
										}}
										placement="top"
										isOpen={this.state["verifikasi" + thisId]}
										target={"verifikasi-" + thisId}
										toggle={() => {
											this.setState({
												["verifikasi" + thisId]:
													!this.state["verifikasi" + thisId],
											});
										}}
									>
										Verifikasi
									</Tooltip>
								</Link>
							</span>
						) : null}

						{record.promotion_status == 1 && accessRole("read") ? (
							<span>
								<Link to={`?detail&uuid=` + this.props.uuid + `&pegawai_uuid=` + record.employee_uuid}>
									<button

										className="btn btn-success btn-sm"
										id={"detail-" + thisId}

										style={{
											marginRight: "2px",
											padding: "2px 5px",
										}}
									>
										<i className="uil-file-search-alt"></i>
									</button>
									<Tooltip
										style={{
											marginBottom: 2,
										}}
										placement="top"
										isOpen={this.state["detail" + thisId]}
										target={"detail-" + thisId}
										toggle={() => {
											this.setState({
												["detail" + thisId]:
													!this.state["detail" + thisId],
											});
										}}
									>
										Detail
									</Tooltip>
								</Link>
							</span>
						) : null}
						{accessRole('delete') && record.promotion_status == 0 ?
							<span>
								<button
									className="btn btn-danger btn-sm"
									type="button"
									id={"delete-" + thisId}
									onClick={() => {
										this.setState({
											inactiveUuid: record.promotion_uuid,
											confirm: true
										})
									}}
									style={{
										padding: '2px 5px'
									}}>
									<i className="uil-trash-alt"></i>
								</button>
								<Tooltip
									style={{
										marginBottom: 2
									}}
									placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
									toggle={() => {
										this.setState({
											["delete" + thisId]: !this.state["delete" + thisId]
										})
									}}
								>Hapus</Tooltip>
							</span>
							: null
						}
					</Fragment>
				);
			},
		},
	];

	render() {
		return (
			<>

				<div className="">
					<b className="me-2">
						Data Terpilih : <Badge className="rounded-pill bg-success font-size-12"> {this.state.dataSelected.length} </Badge> dari total <Badge className="rounded-pill bg-warning font-size-12"> {this.state.totalRow} </Badge>
					</b>

					<Button
						className="me-2"
						color="primary"
						onClick={
							() => {
								this.toggleModalSKC()
							}
						}
						disabled={this.state.dataSelected.length > 0 ? false : true}
					>Buat SK Kolektif</Button>
					<Button
						className="me-2"
						color="warning"
						onClick={
							() => {
								this.handleButtonImportUsulan()
							}
						}
					>Import data usulan</Button>

					{' '}
					{
						(accessRole('print')) ?
							<Button
								className="float-end"
								color="success"
								onClick={
									() => {
										this.handleButtonExportUsulan()
									}
								}
							>Export Data Usulan</Button>
							: null
					}
				</div>

				<hr />

				<Card outline color="primary" className="border">
					<CardHeader className="bg-transparent">
						<h5 className="my-0 text-primary">
							SK Kolektif
						</h5>
					</CardHeader>
					<CardBody>
						<div className="table-responsive">
							<Table className="table-bordered table-striped">
								<thead>
									<tr>
										<th>No</th>
										<th>Nomor SK</th>
										<th>Tanggal SK</th>
										<th>Jumlah Pegawai</th>
										<th>Download</th>
									</tr>
								</thead>
								<tbody>
									{
										this.state.skc_list?.length > 0 ?
											this.state.skc_list?.map((val, i) => {
												return (
													<tr key={i}>
														<td>{++i}</td>
														<td>{val.promotion_collective_decree_number}</td>
														<td>{this.dateParse(val.promotion_collective_decree_date)}</td>
														<td>{val.employee_total}</td>
														<td>
															<button
																className="btn btn-info btn-sm"
																id={"draftSkC-" + val.promotion_collective_decree_id}
																onClick={() => {
																	this.indexBloc.fetchDownloadSKC({
																		uuid: val.promotion_collective_decree_uuid
																	});
																}}
																style={{
																	marginRight: '2px',
																	padding: '2px 5px'
																}}>
																<i className="uil-file-download-alt"></i>
															</button>

															<button
																className="btn btn-danger btn-sm"
																id={"removeSkC-" + val.promotion_collective_decree_id}
																onClick={() => {
																	this.setState({
																		inactiveSKUuid: val.promotion_collective_decree_uuid,
																		confirm: true
																	})
																}}
																style={{
																	marginRight: '2px',
																	padding: '2px 5px'
																}}>
																<i className="uil-trash-alt"></i>
															</button>
														</td>
													</tr>
												)
											})
											:
											<tr>
												<td colSpan="5" className="text-center">Tidak Ada SK Kolektif</td>
											</tr>
									}
								</tbody>
							</Table>
						</div>
					</CardBody>
				</Card>

				<hr />

				<MKIDatatable
					className={this.configDatatable.tableClass}
					config={this.configDatatable}
					records={this.state.rows}
					columns={this.columns}
					dynamic={true}
					minWidth={1000}
					total_record={this.state.totalRow}
					initial={this.state.filter}
					onChange={(filter) => {
						this.setState(
							{
								loadingTable: true,
								filter: filter,
							},
							function () {
								this.setTokenAPI();
							}
						);
					}}
					loading={this.state.loadingTable}
				/>

				{/* Import Modal with Excel Processing */}
				<Modal
					isOpen={this.state.showModalImportUsulan}
					toggle={this.handleCloseModalImportUsulan}
					centered
					size="lg"
				>
					<ModalHeader toggle={this.handleCloseModalImportUsulan}>
						Import Data Usulan
					</ModalHeader>
					<AvForm
						className="needs-validation"
						onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
					>
						<ModalBody>
							{/* Unduh Template */}
							<Row className="mb-3">
								<label className="col-md-3 col-form-label">
									Template
								</label>
								<Col md="9">
									{this.state.downloadingFile ? (
										<>
											<Spinner size="sm" /> Mengunduh...
										</>
									) : (
										<Button
											color="info"
											outline
											onClick={this.handleButtonExportTemplate}
										>
											<i className="mdi mdi-download me-1"></i>
											Unduh Template Data Usulan
										</Button>
									)}
								</Col>
							</Row>

							<hr />

							{/* Upload & Process File */}
							<Row className="mb-3">
								<label className="col-md-3 col-form-label">
									File Excel <span className="text-danger">*</span>
								</label>
								<Col md="9">
									<div className="input-group">
										<input
											ref={this.fileInputRef}
											type="file"
											className="form-control"
											accept=".xlsx,.xls"
											onChange={this.handleExcelFileChange}
										/>
										<Button
											color="primary"
											onClick={this.processExcelFile}
											disabled={!this.state.excelFileName || this.state.processingExcel}
										>
											{this.state.processingExcel ? (
												<>
													<Spinner size="sm" className="me-1" />
													Memproses...
												</>
											) : (
												<>
													<i className="mdi mdi-file-excel me-1"></i>
													Proses Excel
												</>
											)}
										</Button>
									</div>
									{/*{this.state.excelFileName && (
										<small className="text-muted d-block mt-1">
											File: {this.state.excelFileName}
										</small>
									)}*/}
								</Col>
							</Row>

							{/* Progress Bar */}
							{this.state.processingExcel && (
								<Row className="mb-3">
									<Col md={{ size: 9, offset: 3 }}>
										<Progress value={this.state.excelProgress} className="mb-2">
											{this.state.excelProgress}%
										</Progress>
										<small className="text-muted">
											Memproses file Excel...
										</small>
									</Col>
								</Row>
							)}

							{/* Error Message */}
							{this.state.excelError && (
								<Row className="mb-3">
									<Col md={{ size: 9, offset: 3 }}>
										<Alert color="danger" className="mb-0">
											<i className="mdi mdi-alert-circle me-1"></i>
											{this.state.excelError}
										</Alert>
									</Col>
								</Row>
							)}

							{/* Summary */}
							{this.state.processedExcelData && (
								<Row className="mb-3">
									<Col md={{ size: 9, offset: 3 }}>
										<Alert color="success" className="mb-2">
											<strong>File berhasil diproses!</strong>
											<ul className="mb-0 mt-2">
												<li>Total Data: {this.state.excelSummary.valid}</li>
											</ul>
										</Alert>

										{this.state.excelValidationErrors.length > 0 && (
											<Alert color="warning">
												<strong>Peringatan Validasi:</strong>
												<div style={{ maxHeight: '150px', overflowY: 'auto' }}>
													<ul className="mb-0 mt-2 small">
														{this.state.excelValidationErrors.slice(0, 10).map((err, idx) => (
															<li key={idx}>{err}</li>
														))}
														{this.state.excelValidationErrors.length > 10 && (
															<li>...dan {this.state.excelValidationErrors.length - 10} peringatan lainnya</li>
														)}
													</ul>
												</div>
											</Alert>
										)}
									</Col>
								</Row>
							)}

							<AvField
								type="hidden"
								name="periode"
								value={this.props.uuid}
							/>
						</ModalBody>

						<ModalFooter>
							<Button
								color="secondary"
								onClick={this.handleCloseModalImportUsulan}
							>
								Batal
							</Button>
							<Button
								color="primary"
								type="submit"
								disabled={!this.state.processedExcelData || this.state.processedExcelData.length === 0 || this.state.loading}
							>
								{this.state.loading ? (
									<>
										<Spinner size="sm" className="me-1" />
										Mengimport...
									</>
								) : (
									<>
										<i className="mdi mdi-upload me-1"></i>
										Import Data
									</>
								)}
							</Button>
						</ModalFooter>
					</AvForm>
				</Modal>


				<ConfirmAlert
					confirmTitle="Konfirmasi!"
					loadingTitle="Mengirim data..."
					loadingInfo="Tunggu beberapa saat"
					successTitle="Berhasil!"
					failedTitle="Gagal!"
					failedInfo="Data gagal disimpan"
					confirmInfo={this.modal_confirm_message}
					successInfo={this.modal_confirm_sucess_message}
					showConfirm={this.state.confirm}
					showLoading={this.state.loading}
					showSuccess={this.state.success}
					showFailed={this.state.failed}
					response={this.confirmResponse}
				/>

				<SKModal
					modal={this.state.modal}
					toggle={() => this.toggle()}
					handleReload={() => this.setTokenAPI()}
					uuid={this.state.inputSKUuid}
				/>

				<SKCollectiveModal
					modal={this.state.modalSKC}
					toggle={() => this.toggleModalSKC()}
					periodUuid={this.props.uuid}
					uuids={this.state.dataSelected}
					handleReload={() => { this.setTokenAPI(); this.fetchListSKCollective(); }}
					uuid={this.state.inputSKUuid}
					selectedCount={this.state.dataSelected.length}
					periodDate={this.props.periodDate}
				/>

				{this.state.detailUuid !== null ? (
					<Redirect
						to={`/kepegawaian/kenaikan_pangkat.html?detail&uuid=${this.props.uuid}&pegawai_uuid=${this.state.detailUuid}`}
					/>
				) : null}

				{this.state.updateUuid !== null ? (
					<Redirect
						to={`/kepegawaian/kenaikan_pangkat.html?addpegawai&uuid=${this.props.uuid}&pegawai_uuid=${this.state.updateUuid}`}
					/>
				) : null}

				{this.state.berkasUuid !== null ? (
					<Redirect
						to={`/kepegawaian/kenaikan_pangkat.html?berkas&uuid=${this.props.uuid}&pegawai_uuid=${this.state.berkasUuid}`}
					/>
				) : null}
			</>
		);
	}
}

export default TableSecondComponent;
